import type { AppVersionInfo } from '@shopexperts/shared'

export const loadedAppVersion = Object.freeze({
  app: 'dashboard',
  channel: 'beta',
  version: '2.2645.1',
  releasedAt: '2026-11-05T08:59:39.663Z',
  minimumSupported: Object.freeze({
    gentle: '2.2645.1',
    error: '2.2640.2',
    unsupported: '2.2628.1',
  }),
}) satisfies Readonly<AppVersionInfo>
